<template>
  <footer>
    <Heading :level="3" class="title">Serviços</Heading>
    <Grid :columns="[6, 6]" :gutter="24">
      <template v-if="loading">
        <SkeletonLoader
          v-for="loader in 6"
          :key="loader"
          class="skeleton"
          data-testid="loader"
          width="100%"
        >
          <div class="loader-area" />
        </SkeletonLoader>
      </template>
      <template v-else>
        <Row
          v-for="row in rows"
          :key="row.label"
          chevron
          has-interaction
          :has-line="row.hasLine"
          :left-title="row.label"
          class="row-item"
          @click="openLink(row.url)"
        >
          <template #icon-left>
            <InitialAvatarIcon :icon="row.icon" size="medium" />
          </template>
          <template #icon-right>
            <BaseIcon icon="EA0080" :colors="NebraskaColors.elementSecondary" />
          </template>
        </Row>
      </template>
    </Grid>
  </footer>
</template>
<script lang="ts" setup>
import {
  Heading,
  Grid,
  Row,
  InitialAvatarIcon,
  BaseIcon,
  SkeletonLoader
} from '@warrenbrasil/nebraska-web';
import { ref, computed, onBeforeUnmount, onMounted } from 'vue';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { IProductService } from '@/modules/products/services/products';

interface Props {
  services: IProductService[];
  loading: boolean;
}
const props = defineProps<Props>();

const mobileWidth = 768;

const isMobile = ref<boolean>(false);

const rows = computed(() => {
  const lineInterval = isMobile.value ? 0 : 1;
  return props.services.map((service, index) => ({
    ...service,
    hasLine: index > lineInterval
  }));
});

function openLink(link: string) {
  window.open(link);
}

function handleResize() {
  isMobile.value = window.innerWidth <= mobileWidth;
}

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});

onMounted(() => {
  window.addEventListener('resize', handleResize);
  handleResize();
});
</script>

<style lang="less" scoped>
.title {
  margin-bottom: @size-spacing-x600;
}
:deep(.row-item) {
  > div {
    padding: @size-spacing-x500 0;
  }
}
.skeleton {
  padding-top: @size-spacing-x75;
}
.loader-area {
  border-radius: @size-radius-x200;
  height: 96px;
}
</style>
